import * as Yup from "yup";
import { emailValidator } from "../../validations";
import {
  CONFIRM_PASSWORD_REQUIRED,
  PASSWORD_MUST_MATCH,
  PASSWORD_REQUIRED,
} from "../../constants/messages";

export const CreateAccountSchema = Yup.object({
  fullName: Yup.string(),
  email: emailValidator,
  password: Yup.string().required(PASSWORD_REQUIRED),
  // current_password: Yup.string()
  //     .required(PASSWORD_REQUIRED)
  //     .transform((value: string) => value.trim()),
  confirmPassword: Yup.string()
    .oneOf([Yup.ref("password"), ""], PASSWORD_MUST_MATCH)
    .required(CONFIRM_PASSWORD_REQUIRED),
});
